import { render, staticRenderFns } from "./CheckImunitate.vue?vue&type=template&id=6d35b174&scoped=true&"
import script from "./CheckImunitate.vue?vue&type=script&lang=js&"
export * from "./CheckImunitate.vue?vue&type=script&lang=js&"
import style0 from "./CheckImunitate.vue?vue&type=style&index=0&id=6d35b174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d35b174",
  null
  
)

export default component.exports